import {
  BrowserRouter as Router,
  Switch,
  Route
} from 'react-router-dom'
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n'
import Auth from './components/Auth'
import Logout from './components/Logout'
import MFP from './components/MFP'
import Processing from './components/Processing'
import Redirect from './components/test/Redirect'
import FromDipa from './components/FromDipa'
import ToDipa from './components/ToDipa'
import NoDipa from './components/NoDipa'
import Success from './components/Success'
import Failure from './components/Failure'
import Split from './components/Split'
import Background from './components/Background'
import Unlicensed from './components/Unlicensed'
import Error from './components/Error'
import Loading from './components/Loading'
import { Release2MeApp } from './components/Release2Me'

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <Router>
        <Switch>
          <Route path="/auth">
            <Auth/>
          </Route>
          <Route path="/logout">
            <Logout/>
          </Route>
          <Route path="/mobile">
            MOBILE
          </Route>
          <Route path="/processing">
            <Processing/>
          </Route>
          <Route path="/redirect">
            <Redirect/>
          </Route>
          <Route path="/dipa-redirect">
            <FromDipa/>
          </Route>
          <Route path="/dipa">
            <ToDipa/>
          </Route>
          <Route path="/no-dipa">
            <NoDipa />
          </Route>
          <Route path="/success">
            <Success />
          </Route>
          <Route path="/failure">
            <Failure />
          </Route>
          <Route path="/split">
            <Split />
          </Route>
          <Route path="/background">
            <Background />
          </Route>
          <Route path="/unlicensed">
            <Unlicensed />
          </Route>
          <Route path="/release2me">
            <Release2MeApp />
          </Route>
          <Route path="/error">
            <Error />
          </Route>
          <Route path="/debug/loading">
            <Loading />
          </Route>
          <Route path="/">
            <MFP/>
          </Route>
        </Switch>
      </Router>
    </I18nextProvider>
  );
}

export default App;
